import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_qhvvqvjwkz: FaireCollectionEntity = {
  token: "pbc_qhvvqvjwkz",
  type: "collection",
  name: "Confetti 🎉🎊",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8d26b550151853b2eed723cf00b59a5a75fc65eeed9e1b7f50efa0d1f54c6922.jpeg",
  itemCount: 12,
  description:
    "Cue the confetti......A twirl-ready dress, magical cape, sparkly clip and tutu, made for birthdays, dress-up, and nonstop party vibes!",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:39.506Z",
    importedBy: "entity-db-import-collections",
  },
};
